import { createSvgIcon } from '@mui/material/utils';

export const PinFilledIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none">
    <path
      d="M0.25359 6.96563L6.98958 0.229636C7.29577 -0.0765454 7.75504 -0.0765454 8.06122 0.229636L10.5107 2.67909C10.8934 3.06182 10.7403 3.52109 10.5107 3.75072L9.97485 4.28654L12.2712 6.5829C13.4194 6.35327 16.5578 5.81745 18.2418 7.50145C18.5479 7.80763 18.5479 8.2669 18.2418 8.57308L13.8787 12.9362L18.701 17.7585C19.0072 18.0647 19.0072 18.524 18.701 18.8302C18.3948 19.1363 17.859 19.0598 17.6294 18.8302L12.807 14.0078L8.44395 18.3709C7.98467 18.7536 7.5254 18.6005 7.37231 18.3709C5.68831 16.6869 6.22413 13.5485 6.45377 12.4004L4.1574 10.104L3.62159 10.6398C3.3154 10.946 2.85613 10.946 2.54995 10.6398L0.1005 8.19036C-0.0525913 7.73108 -0.0525913 7.27181 0.25359 6.96563Z"
      fill="currentColor"
    />
  </svg>,
  'PinFilled',
);
